import PropTypes from 'prop-types';
import { Col, Row, Stack } from 'components/ui';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AvatarEdit } from 'components/impfschaeden/assistent/components/AvatarEdit.js';
import { ChooseAvatarDialog } from 'components/impfschaeden/assistent/components/ChooseAvatarDialog.js';
import { useTranslation } from 'react-i18next';

const UserImg = styled.img`
	max-width: 200px;
`;

const ProfilbildForm = ({ internal, formData, edit, updateUser }) => {
	let avatarId = internal
		? formData.avatar_glob_file_id
		: edit
		? useSelector((state) => state.vaxEditData.avatar_glob_file_id)
		: useSelector((state) => state.vaxFormData.avatar_glob_file_id);
	if (internal) {
		avatarId = formData.user?.avatar_glob_file_id;
	}
	if (internal == 'register') {
		avatarId = useSelector((state) => state.vaxFormData.avatar_glob_file_id);
	}
	const avatarLink = `${process.env.API_URL}v1/glob/files/${avatarId}/avatar.png`;
	const [t] = useTranslation();
	return (
		<>
			<Row className='d-flex justify-content-md-start justify-content-xs-center'>
				<Col
					md={'auto'}
					className='d-flex justify-content-center mb-lg-0 mb-md-2 mb-sm-3 mb-3'
				>
					{avatarId ? (
						<UserImg
							src={avatarLink}
							alt='avatar'
							style={{ borderRadius: '50%' }}
						/>
					) : (
						<UserImg
							src='/img/placeholder.png'
							alt='avatar'
							style={{ borderRadius: '50%' }}
						/>
					)}
				</Col>
				<Col className='my-auto' md={'auto'}>
					<Stack gap={2}>
						<AvatarEdit
							internal={
								internal == 'register'
									? 'register'
									: internal
									? 'user'
									: edit
									? 'edit'
									: ''
							}
							update={updateUser}
						/>
						<div className='d-flex justify-content-center'>
							{t('common.oder')}
						</div>
						<ChooseAvatarDialog
							updateUser={updateUser}
							internal={internal}
							edit={edit}
							formData={formData}
						/>
					</Stack>
				</Col>
			</Row>
		</>
	);
};

ProfilbildForm.propTypes = {
	update: PropTypes.string,
	formData: PropTypes.object,
	validation: PropTypes.object,
	internal: PropTypes.bool || PropTypes.undefined,
	edit: PropTypes.bool || PropTypes.undefined,
	updateUser: PropTypes.func,
};

export { ProfilbildForm };
